export default {
  posts: {
    0: {
      title: "Commence 🏁",
      content: `I’m starting to get the impression that what's done is only done if done in relation.  To that end- and as it’s the beginning of Tone Row... let the blogging commence.`,
      date: 1560982513912
    }
  }
};
